module.exports = __webpack_public_path__ + "img/slider-arrow-left.14432f56.svg";